import axios from 'axios'
import { API_LOCATOR } from '@/config/api.config'

export async function getSearchConsoleDataLocal(clientId, slug, period) {
  const response = await axios.get(
    `${API_LOCATOR.BASE_API_URL}/clients/${clientId}/dashboards/seo-insights?period=${period}&locatorSlug=${slug}`
  )
  return response.data
}

export async function getGa4DataLocal(clientId, slug, period) {
  const response = await axios.get(
    `${API_LOCATOR.BASE_API_URL}/clients/${clientId}/dashboards/analytic?period=${period}&locatorSlug=${slug}`
  )
  return response.data
}
